'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMarkdownRenderer = require('react-markdown-renderer');

var _reactMarkdownRenderer2 = _interopRequireDefault(_reactMarkdownRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Markdown = function (_React$Component) {
  _inherits(Markdown, _React$Component);

  function Markdown() {
    _classCallCheck(this, Markdown);

    return _possibleConstructorReturn(this, (Markdown.__proto__ || Object.getPrototypeOf(Markdown)).apply(this, arguments));
  }

  _createClass(Markdown, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'markdown', 'data-building-block': 'organism' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 center-block' },
              _react2.default.createElement(_reactMarkdownRenderer2.default, {
                options: { html: true },
                markdown: this.props.content.input.text
              })
            )
          )
        )
      );
    }
  }]);

  return Markdown;
}(_react2.default.Component);

exports.default = Markdown;


Markdown.defaultProps = {
  content: {
    input: {
      text: '# Markdown\n## Purpose\nAllows the creation of content utilizing industry standard markdown formatting commands.\n\nMarkdown tags in the grey box below and then immediately below rendered as HTML*\n*PayPal CSS styles will be applied and should not be overridden.\n\n#### Linked Text\nFor tracking purposes, within the Markdown organism, all links placed should include the data-pa-click parameters as follows:\n\n```\nSign up for free at <a href="http://www.paypal.com" data-pa-click="Markdown-HtchTxt-PayPal">PayPal</a> today.\n```\n\nIn the above example, the data-pa-click parameter identifies: the organism "markdown", the link "Hatch Text", and the linked text "PayPal"\n\n[//]: # (These are reference links used in the body of this note and get stripped out when the markdown processor does its job.)\n\n### Tables\n| 1  | 2  | 3   | 4  | 5  |\n|----|----|-----|----|----|\n| 6  | 7  | 8   | 9  | 10 |\n| 11 | 12 | 13  | 14 | 15 |\n| 16 | 17 | 18  | 19 | 20 |\n\n### Lists\n- List Example:\n  - Value\n  - value\n\n- List Example\n  - Bring DEET'
    }
  }
};

Markdown.propTypes = {
  content: _propTypes2.default.shape({
    input: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  })
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/markdown/jsx/Markdown.js
// module id = 1117
// module chunks = 4